import { render } from "./SponsorsSectionItemImage.vue?vue&type=template&id=62ce16dd"
import script from "./SponsorsSectionItemImage.vue?vue&type=script&lang=js"
export * from "./SponsorsSectionItemImage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__